import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

import { EvaluationProps } from './Evaluation.type'

const borderColor = {
  success: '#74EC81',
  error: '#FF7373',
  default: '#006bff'
}

export const Container = styled.div<{ heightClass: HeightClass }>`
  display: flex;
  flex-direction: column;

  gap: ${({ theme, heightClass }) =>
    theme.evaluation[heightClass].defaultSpace}px;

  padding: ${({ theme, heightClass }) =>
    theme.evaluation[heightClass].containerPadding}px;
`

export const Options = styled.ul<{
  heightClass: HeightClass
  direction: EvaluationProps['direction']
}>`
  list-style: none;
  display: flex;

  flex-direction: ${({ direction }) =>
    direction === 'horizontal' ? 'row' : 'column'};

  align-items: flex-start;

  gap: ${({ theme, heightClass }) =>
    theme.evaluation[heightClass].defaultSpace}px;

  margin: 0;
  padding: 0;
`

export const Option = styled.li<{
  heightClass: HeightClass
  direction: EvaluationProps['direction']
}>`
  display: flex;

  flex-direction: ${({ direction }) =>
    direction === 'horizontal' ? 'column' : 'row'};

  align-items: center;

  gap: ${({ theme, heightClass }) =>
    theme.evaluation[heightClass].defaultSpace}px;
`

export const Input = styled.input.attrs({
  type: 'checkbox'
})<{ heightClass?: HeightClass; status?: 'default' | 'success' | 'error' }>`
  display: inline-block;
  margin: 0;
  border-radius: 50%;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  width: ${({ theme, heightClass = 'regular' }) =>
    theme.explicitSelectionButton[heightClass]?.width || 0}px;

  height: ${({ theme, heightClass = 'regular' }) =>
    theme.explicitSelectionButton[heightClass]?.height || 0}px;

  &:before {
    content: '';
    position: absolute;
    border-radius: 100%;

    ${({ theme, heightClass = 'regular', status = 'default' }) =>
      `
        border-width: ${theme.explicitSelectionButton[heightClass]?.borderSize || 0}px;
        border-style: solid;
        border-color: ${borderColor[status]};
      `};

    width: ${({ theme, heightClass = 'regular' }) =>
      theme.explicitSelectionButton[heightClass]?.width || 0}px;

    height: ${({ theme, heightClass = 'regular' }) =>
      theme.explicitSelectionButton[heightClass]?.height || 0}px;

    transition: background 0.15s;
  }

  &:checked {
    &:before {
      background-color: #006bff;
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:disabled:before {
    border-style: dashed;
  }

  &[aria-readonly='true'] {
    &:before {
      border-style: solid;
      border-color: #abbed1;
    }

    &:checked {
      &:before {
        background-color: #abbed1;
      }
    }
  }

  &[tabindex='-1'] {
    border: 0.5px solid #006bff;
    border-radius: 0;

    &:before {
      margin-left: -1px;
      margin-top: -1px;
    }
  }

  &:focus {
    &:before {
      border-color: #abbed1;
    }
  }
`

export const Separator = styled.hr`
  width: 100%;
  height: 2px;
  background-color: #abbed1;
  margin: 0;
`
